import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import api from './api'

require('./assets/css/style.css')


import AntD from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';
var app = createApp(App);
app.use(AntD)

import * as Icons from "@ant-design/icons-vue";

const icons = Icons;

for (const i in icons) {
  app.component(i, icons[i]);
}

app.use(api).use(router).mount('#app')


